import { render, staticRenderFns } from "./TopNetworks.vue?vue&type=template&id=08514bc8"
import script from "./TopNetworks.vue?vue&type=script&lang=js"
export * from "./TopNetworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports